import React, {type CSSProperties, type FC, type PropsWithChildren} from 'react'
import clsx from 'clsx'
import type {TableType} from '../types'
import styles from './Cell.scss'

export type CellProps = {
  align?: 'left' | 'center' | 'right'
  width?: number | string
  className?: string
  type?: TableType
  isHighlighted?: boolean
} & PropsWithChildren

const alignTojc = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
}

export const Cell: FC<CellProps> = (props) => {
  const {children, className, align, width, type = 'admin', isHighlighted} = props

  const style: CSSProperties = {}

  if (align) {
    style['justifyContent'] = alignTojc[align]
  }

  if (width !== undefined) {
    style['width'] = width
  }

  return (
    <div className={clsx(
        styles.cell,
        styles[`cell__${type}`],
        {[styles[`cell__${type}--highlighted`]]: isHighlighted},
        className,
      )}
      style={style}
    >
      {children}
    </div>
  )
}
